import Meta from "../common/Meta";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import React from "react";
import Grid from "@mui/material/Grid";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import EventPackages from "./EventPackages";
import Footer from "../Footer";

export default function ViewEventPackages() {

  return (
    <DashboardLayout>
      <Meta pageTitle={'View Event Packages'}/>
      <ContextSearchNavbar title={'View Event Packages'}/>
      <MDBox py={3}>
        <MDBox mb={3}>
          <EventPackages />
        </MDBox>
      </MDBox>

      <Footer mt={5}/>

    </DashboardLayout>
  )
}